import React from "react";
import PropTypes from "prop-types";

const Attribute = ({ name, value }) => (
  <div className="flex pb-2">
    <div className="font-bold">{`${name}:`}</div>
    <div className="ml-2">{value}</div>
  </div>
);

Attribute.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default Attribute;
